var translateCorexError = function (text) {
    var transformedMessage = text
        .trim()
        .toLowerCase()
        .replaceAll(' ', '_')
        .replaceAll(',', '');
    if (transformedMessage.endsWith('.')) {
        transformedMessage = transformedMessage.slice(0, -1);
    }
    return transformedMessage;
};

export { translateCorexError };
